var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid"},[_c('div',{staticClass:"p-col-12"},[_vm._v(" Page not found ")])])
}]

export { render, staticRenderFns }